import React, { useState } from 'react';
import '../styles/HelpCenter.css';

function HelpCenter({ onBack, onContactSupport }) {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const faqs = [
    {
      question: 'How do I create a group chat?',
      answer: 'To create a group chat, tap on the Groups tab, then tap the "+" button at the bottom. Select the contacts you want to add, give your group a name, and tap Create. You can add up to 256 members in a group.'
    },
    {
      question: 'How do I send voice messages?',
      answer: 'To send a voice message, tap and hold the microphone icon in the message input area. Start speaking while holding the button. Release to send, or slide left to cancel the recording.'
    },
    {
      question: 'How do I make voice or video calls?',
      answer: 'Open any chat conversation and tap the phone icon at the top for voice calls or the video camera icon for video calls. Make sure you have a stable internet connection for the best call quality.'
    },
    {
      question: 'How do I change my profile picture?',
      answer: 'Go to Settings > tap on your profile picture > select "Edit Profile" > tap on the camera icon to upload a new photo. You can choose from your gallery or take a new photo.'
    },
    {
      question: 'How do I block someone?',
      answer: 'Open the person\'s profile and scroll to the bottom to find the Block Contact button, or open the chat with that person and tap the three dots in the top-right corner to reveal the Block option.'
    },
    {
      question: 'How do I change chat wallpaper?',
      answer: 'Open any chat > tap the three dots menu > select "Wallpaper" > choose from available wallpapers or upload your own custom image.'
    },
    {
      question: 'How do I delete messages?',
      answer: 'Long press on any message to open the context menu, then select "Delete". You can choose to delete the message for yourself or for everyone in the chat.'
    },
    {
      question: 'How do I share my location?',
      answer: 'Tap the attachment icon in the chat > select "Location" > choose to share your current location or select a location from the map. Your location will be shared as a message with an interactive map.'
    },
    {
      question: 'How do I send photos and videos?',
      answer: 'Tap the attachment icon > select "Gallery" to choose existing photos/videos, or "Camera" to take a new photo/video. You can also add captions before sending.'
    },
    {
      question: 'How do I enable notifications?',
      answer: 'Toggle Enable Push Notifications at the bottom of your profile page, or go to Settings > Notifications and switch on push notifications there. Also confirm your device or browser allows notifications from Ucmaapp.'
    },
    {
      question: 'How do I see who viewed my vibe?',
      answer: 'Go to the Vibe tab > tap on "My Vibe" > swipe up to see the list of contacts who have viewed your vibe updates.'
    },
    {
      question: 'How do I leave a group?',
      answer: 'Open the group chat > tap the group name at the top > scroll down > tap "Exit Group". You will no longer receive messages from this group.'
    },
    {
      question: 'Can I use Ucmaapp on multiple devices?',
      answer: 'Currently, Ucmaapp works on one device at a time. If you log in on a different device, you will be automatically logged out from the previous device.'
    },
    {
      question: 'How do I report a problem?',
      answer: 'Go to Settings > Help > Contact Us to report any issues. Provide detailed information about the problem you\'re experiencing, and our support team will assist you.'
     }
    //, {
    //   question: 'How do I change app language?',
    //   answer: 'Go to Settings > App Language > select your preferred language from the list. The app interface will be translated to your chosen language.'
    // }
  ];

  const toggleFAQ = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="help-center-container">
      <div className="help-center-header">
        <button className="back-button" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5"/>
            <path d="M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2>Help Center</h2>
      </div>

      <div className="help-center-content">
        <div className="help-center-intro">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="help-center-icon">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <h3>Frequently Asked Questions</h3>
          <p>Find answers to common questions about using Ucmaapp</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h4>{faq.question}</h4>
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                  className={`faq-toggle-icon ${expandedIndex === index ? 'rotated' : ''}`}
                >
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </div>
              {expandedIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="help-center-footer">
          <p>Can't find what you're looking for?</p>
          <button
            className="contact-support-btn"
            onClick={() => {
              if (typeof onContactSupport === 'function') {
                onContactSupport();
              } else {
                window.history.back();
              }
            }}
          >
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;

